import { MENU_KEY_ROUTES } from "src/constants/modules";
import { HotelSearch, HotelsListing } from "src/Modules/Hotels";
import HotelBookingResult from "src/Modules/Hotels/Pages/HotelBookingResult/HotelBookingResult";
import HotelsWrapper from "src/Modules/Hotels/HotelsWrapper";
import HotelBookingLoader from "src/Modules/Hotels/Pages/HotelBooking/HotelBooking.loader";
import HotelDetailsLoader from "src/Modules/Hotels/Pages/HotelDetails/HotelDetails.loader";


export const hotelRoutes = {
  path: MENU_KEY_ROUTES["Hotel"],
  element: <HotelsWrapper />,
  children: [
    {
      index: true,
      element: <HotelSearch />,
    },
    {
      path: ":searchId",
      children: [
        {
          index: true,
          element: <HotelsListing />,
        },
        {
          path: "hotel/:hotelKey",
          element: <HotelBookingLoader />,
        },
        {
          path:"hotel/:hotelKey/book/:hotelDetailsKey/:step?",
          element:<HotelDetailsLoader/>
        },
      ],
    },
    {
      path:"booking-result/:hotelDetailsKey",
      element:<HotelBookingResult />,
    }
  ],
};
